import styled from 'styled-components'
import { Alert as AntAlert } from 'antd'

import { Upload as AntUpload } from 'src/components/Ant'

export const Alert = styled(AntAlert)`
  margin-top: 12px;
`

export const Upload = styled(AntUpload)`
  display: flex;
`
